<template>
  <div>
    <nav class="navbar navbar-expand navbar-light fixed-top">
      <div class="container">
        <a class="navbar-brand" href="#">
          <img
            @click="clickLogo()"
            class="d-block"
            src="/img/LogoPortoBank1.svg"
            height="23vh"
          />
        </a>
        <button
          class="navbar-toggler navbar-toggler-right border-0 collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#navbar4"
          aria-expanded="false"
        >
          <span class="navbar-toggler-icon small"></span>
        </button>
        <div class="navbar-collapse collapse" id="navbar4">
          <p class="small text-info title-space mb-2 mt-2">
            Negocie Porto Bank
          </p>
          <ul class="navbar-nav ml-auto text-center"></ul>
          <div class="space1 d-none d-sm-block"></div>
          <div class="text-center">
            <a class="btn btn-zul ml-auto" href="#">Negociar</a>
          </div>
        </div>
      </div>
    </nav>
    <router-view></router-view>
    <div class="footer1 text-light py-4" style="background: #000">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-5"></div>
        </div>
      </div>
    </div>
    <a
      @click="saveLogcontatoWhatsApp"
      class="whatsapp-link"
      href="https://porto.vc/whatsapp-oficial"
      target="_blank"
    >
      <i
        v-bind:class="[
          largura < 500 ? 'fa fa-whatsapp fa-2x' : 'fa fa-whatsapp fa-3x',
        ]"
      ></i>
    </a>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { ActionGetIPAddress } from "@/utils/helpers";

export default {
  name: "Landing",
  components: {},
  data: () => ({
    authlinks: [{ icon: "", text: "Início", route: "/dashboard" }],
    hrefwhatsapp: "https://api.whatsapp.com/send?l=pt&phone=551132303765",
    links: [
      { icon: "", text: "Quem Somos", route: "somos" },
      { icon: "", text: "Experimente", route: "experimente" },
      { icon: "", text: "Termos de uso", route: "termos" },
      { icon: "", text: "Política de privacidade", route: "sobre" },
      { icon: "", text: "Política de cookies", route: "sobre" },
    ],
    largura: null,
    ipUser: null,
  }),
  methods: {
    ...mapActions("auth", [
      "ActionDoLogout",
      "ActionMenuLinks",
      "ActionGetUser",
      "ActionGetWhatsText",
      "ActionContatoWhatsapp",
    ]),
    ...mapActions("meusBoletos", ["ActionSendAccessLogWithoutToken"]),

    async openWhats() {
      if (this.user != null) {
        var whats = await this.ActionGetWhatsText();
        this.hrefwhatsapp = this.hrefwhatsapp + "&text=" + whats[0];
      } else {
        // console.log('registrando log...');
        await this.ActionSendAccessLogWithoutToken({
          ValueId: 16,
        });
        this.hrefwhatsapp =
          this.hrefwhatsapp +
          "&text=Olá, não encontrei meus dados podem me ajudar ?";

        // console.log('log registrado.');
      }

      window.open(this.hrefwhatsapp, "_blank");
    },

    async saveLogcontatoWhatsApp() {
      this.ActionContatoWhatsapp({
        DocNumber: localStorage.getItem("doc") ?? null,
        tag: "Padrao",
        IP: this.ipUser ? this.ipUser : "",
      });

      this.clickWhatsapp();
    },

    clickLogo() {
      const pageName = this.$options.name;
      const eventCategory = `portal-de-negociacao:porto:${pageName}`;
      const eventAction = "click:logo:porto-bank";
      console.log("eventCategory: " + JSON.stringify(eventCategory));
      console.log("eventAction: " + JSON.stringify(eventAction));

      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: "",
      };

      window.dataLayer.push({ event: "select_content", ...eventData });
    },

    clickWhatsapp() {
      const pageName = this.$options.name;
      const eventCategory = `portal-de-negociacao:porto:${pageName}`;
      const eventAction = "click:fab:whatsapp";
      console.log("eventCategory: " + JSON.stringify(eventCategory));
      console.log("eventAction: " + JSON.stringify(eventAction));

      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: "",
      };

      console.log("eventData: " + JSON.stringify(eventData));

      window.dataLayer.push({ event: "select_content", ...eventData });
    },

    async getIPAddressUser() {
      let maxAttempts = 10;
      let attempts = 0;

      while (attempts < maxAttempts) {
        try {
          this.ipUser = await ActionGetIPAddress();
          break; // Saia do loop se o IP for obtido com sucesso
        } catch (error) {
          console.log("Erro ao obter o endereço IP. Tentando novamente...");
          attempts++;
          await new Promise((resolve) => setTimeout(resolve, 1000)); // Aguarde 1 segundo antes de tentar novamente
        }
      }

      if (attempts === maxAttempts) {
        console.log(
          "Número máximo de tentativas atingido. Não foi possível obter o endereço IP."
        );
      }
    },
  },
  async created() {
    await this.getIPAddressUser();
    this.largura = window.screen.width;
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
  },
};
</script>
<style scoped>
html {
  margin-top: -57px;
}
</style>
